const WIPAY_ENDPOINTS = {
  jamaica: "https://jm.wipayfinancial.com/plugins/payments/request",
  trinidad: "https://tt.wipayfinancial.com/plugins/payments/request",
  barbados: "https://bb.wipayfinancial.com/plugins/payments/request",
  guyana: "https://gy.wipayfinancial.com/plugins/payments/request",
};

export const WIPAY_CONFIG = {
  endpoint: process.env.REACT_APP_WIPAY_ENDPOINT || WIPAY_ENDPOINTS.jamaica,
  accountNumber: process.env.REACT_APP_WIPAY_ACCOUNT_NUMBER || "1234567890",
  countryCode: process.env.REACT_APP_WIPAY_COUNTRY_CODE || "JM",
  environment: process.env.REACT_APP_WIPAY_ENVIRONMENT || "sandbox",
  currency: process.env.REACT_APP_WIPAY_CURRENCY || "JMD",
  total: process.env.REACT_APP_WIPAY_BOOKING_TOTAL || "1000.00",
  feeStructure: process.env.REACT_APP_WIPAY_FEE_STRUCTURE || "customer_pay",
  method: process.env.REACT_APP_WIPAY_METHOD || "credit_card",
  origin: process.env.REACT_APP_WIPAY_ORIGIN || "BeDentalParadise",
};

const PENDING_WIPAY_KEY = "bdp_pending_wipay_payment";

function getResponseUrl() {
  if (process.env.REACT_APP_WIPAY_RESPONSE_URL) {
    return process.env.REACT_APP_WIPAY_RESPONSE_URL;
  }

  return `${window.location.origin}/payment/success`;
}

function appendHiddenInput(form, name, value) {
  const input = document.createElement("input");
  input.type = "hidden";
  input.name = name;
  input.value = value;
  form.appendChild(input);
}

export function buildWipayPayload({ appointment, form }) {
  const paymentData = {
    appointment_id: appointment.id,
    patient_name: form.name,
    email: form.email,
    phone: form.phone,
    problem: form.problem,
    preferred_date: appointment.preferred_date,
    preferred_time: appointment.preferred_time,
  };

  return {
    endpoint: WIPAY_CONFIG.endpoint,
    fields: {
      account_number: WIPAY_CONFIG.accountNumber,
      avs: "0",
      country_code: WIPAY_CONFIG.countryCode,
      currency: WIPAY_CONFIG.currency,
      data: JSON.stringify(paymentData),
      environment: WIPAY_CONFIG.environment,
      fee_structure: WIPAY_CONFIG.feeStructure,
      method: WIPAY_CONFIG.method,
      order_id: appointment.id,
      origin: WIPAY_CONFIG.origin,
      response_url: getResponseUrl(),
      total: WIPAY_CONFIG.total,
    },
  };
}

export function storePendingWipayPayment(payload) {
  window.sessionStorage.setItem(PENDING_WIPAY_KEY, JSON.stringify(payload));
}

export function readPendingWipayPayment() {
  const raw = window.sessionStorage.getItem(PENDING_WIPAY_KEY);
  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function clearPendingWipayPayment() {
  window.sessionStorage.removeItem(PENDING_WIPAY_KEY);
}

export function submitWipayPayload(payload) {
  const wipayForm = document.createElement("form");
  wipayForm.method = "POST";
  wipayForm.action = payload.endpoint;
  wipayForm.style.display = "none";

  Object.entries(payload.fields).forEach(([name, value]) => {
    appendHiddenInput(wipayForm, name, value);
  });

  document.body.appendChild(wipayForm);
  wipayForm.submit();
}

export function submitWipayPayment({ appointment, form }) {
  submitWipayPayload(buildWipayPayload({ appointment, form }));
}
